<template>
  <div class="student-poster" :class="[mainStyle, mapSize, mapLayout, $root.env]">
    <div class="student-poster-container">
      <img class="student-poster-background" :class="[mainStyle]" :src="backgroundImage"/>
      <div class="student-poster-image" :class="[mainStyle]">
        <img
            v-if="cropImg"
            :src="cropImg"
            alt="Cropped Image"
        />
      </div>
    </div>
  </div>
</template>

<script>
import StudentPosterModule from '../store-mixin'

export default {
  name: 'StudentPoster',
  mixins: [StudentPosterModule()],
  computed: {
    backgroundImage() {
      return window.lovemap?.studentsPoster?.background?.[this.mainStyle] ?? ''
    }
  }
}
</script>

<style lang="scss" scoped>


img {
  width: 100%;
  height: auto
}

.student-poster {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  position: relative;

  .student-poster-background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;

    height: 100%;
    width: 100%;
  }

  .student-poster-container{
    width: 100%;
    height: 100%;
  }

  .student-poster-image {
    position: absolute;
    z-index: 1;

    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &.style-0 {
      top: 315px;
      bottom: 235px;
      left: 108px;
      right: 108px;
    }

    &.style-1 {
      top: 130px;
      bottom: 290px;
    }
    &.style-2 {
      bottom: 340px;
    }
  }

  //::v-deep * {
  //  color: black;
  //  font-size: 72px;
  //  font-family: unset;
  //  margin: 0;
  //}


  //.main {
  //  padding-top: 14px;
  //
  //  ::v-deep * {
  //    font-family: SF Slapstick Comic Shaded;
  //    font-size: 72px;
  //    margin: 0;
  //    line-height: 0;
  //    margin-bottom: 100px;
  //    letter-spacing: 1px;
  //  }
  //}
  //
  //.secondary {
  //  margin: 10px;
  //
  //  ::v-deep {
  //    font-family: Montserrat B;
  //    font-size: 27px;
  //    font-weight: bold;
  //    letter-spacing: -0.3px;
  //  }
  //}

}
</style>

